if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.prevButton = this.querySelector('[data-product-media-modal-prev]');
        this.nextButton = this.querySelector('[data-product-media-modal-next]');

        if (this.prevButton) {
          this.prevButton.addEventListener('click', this.showPreviousMedia.bind(this));
          // Prevent the modal's "click outside to close" (bound to pointerup) from firing on arrow clicks
          this.prevButton.addEventListener('pointerup', (event) => event.stopPropagation());
        }
        if (this.nextButton) {
          this.nextButton.addEventListener('click', this.showNextMedia.bind(this));
          this.nextButton.addEventListener('pointerup', (event) => event.stopPropagation());
        }
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        this.activateMedia(activeMedia);
      }

      activateMedia(activeMedia) {
        if (!activeMedia) return;

        this.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('active');
        });

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      showPreviousMedia(event) {
        if (event) event.preventDefault();
        const items = this.querySelectorAll('[data-media-id]');
        if (items.length < 2) return;
        const currentIndex = Array.from(items).findIndex((item) => item.classList.contains('active'));
        const previousIndex = currentIndex <= 0 ? items.length - 1 : currentIndex - 1;
        this.activateMedia(items[previousIndex]);
      }

      showNextMedia(event) {
        if (event) event.preventDefault();
        const items = this.querySelectorAll('[data-media-id]');
        if (items.length < 2) return;
        const currentIndex = Array.from(items).findIndex((item) => item.classList.contains('active'));
        const nextIndex = currentIndex === -1 || currentIndex === items.length - 1 ? 0 : currentIndex + 1;
        this.activateMedia(items[nextIndex]);
      }
    }
  );
}
